export enum CORRECTNESS {
  WRONG,
  PARTIAL,
  CORRECT
}
